import { render, staticRenderFns } from "./PackageListModal.vue?vue&type=template&id=04d089b0&scoped=true&"
import script from "./PackageListModal.vue?vue&type=script&lang=js&"
export * from "./PackageListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d089b0",
  null
  
)

export default component.exports